/**
 * Mock Candle Card.
 *
 * Seeded with one report from each of the four bots, in their real summary
 * shapes, so the adapters and the section can be exercised with no backend —
 * including the mix the client actually sees: some reviewed by a doctor, one
 * still waiting.
 */

const MOCK = {
  tier: 'pro',
  photosKeptUntil: new Date(Date.now() + 300 * 86400000).toISOString(),
  cards: [
    {
      id: 'card-mock-1', typeCode: 'pro', status: 'active', retentionDays: 365,
      pricePaid: 12900000,
      activatedAt: new Date(Date.now() - 65 * 86400000).toISOString(),
      expiresAt: new Date(Date.now() + 300 * 86400000).toISOString(),
      name: { fa: 'کندل کارت حرفه‌ای', en: 'Candle Card Pro' },
    },
  ],
  plans: [
    { code: 'care_6m', tier: 'free', retentionDays: 182, priceToman: 4900000,
      features: ['compare'], isActive: true, sortOrder: 10,
      name: { fa: 'کارت مراقبت ۶ ماهه', en: '6-month Care Card' },
      description: { fa: 'تصاویر شما تا شش ماه نگهداری می‌شود.',
        en: 'Your photos are kept for six months.' } },
    { code: 'care_12m', tier: 'free', retentionDays: 365, priceToman: 8900000,
      features: ['compare'], isActive: true, sortOrder: 20,
      name: { fa: 'کارت مراقبت ۱۲ ماهه', en: '12-month Care Card' },
      description: { fa: 'تصاویر شما تا یک سال نگهداری می‌شود.',
        en: 'Your photos are kept for a year.' } },
    { code: 'pro', tier: 'pro', retentionDays: 365, priceToman: 12900000,
      features: ['compare', 'priority_support', 'history'], isActive: true, sortOrder: 30,
      name: { fa: 'کندل کارت حرفه‌ای', en: 'Candle Card Pro' },
      description: { fa: 'یک سال نگهداری تصاویر، همراه با سوابق و گزارش‌های شما در یک کارت.',
        en: 'A year of photo cover, with your records and reports on one card.' } },
    { code: 'special_care', tier: 'special_care', retentionDays: 365, priceToman: 22900000,
      features: ['compare', 'priority_support', 'history', 'care_team'],
      isActive: true, sortOrder: 40,
      name: { fa: 'کندل کارت مراقبت ویژه', en: 'Candle Card Special Care' },
      description: { fa: 'همه‌ی امکانات حرفه‌ای، به‌همراه پیگیری اختصاصی تیم مراقبت.',
        en: 'Everything in Pro, with the care team following your case.' } },
  ],
  reports: [
    {
      consultationId: 'cons-mock-1', analysisId: 'an-mock-1', agentKey: 'tern',
      serviceName: { fa: 'تحلیل هوشمند چهره (بوتاکس)', en: 'AI face analysis (Botox)' },
      state: 'reviewed', physicianName: 'دکتر نیلوفر کریمی',
      at: new Date(Date.now() - 6 * 86400000).toISOString(),
      reviewedAt: new Date(Date.now() - 5 * 86400000).toISOString(),
      metrics: {
        measures: [], overallSymmetry: 87.3, lowerSide: 'left',
        regions: { brow: 91.2, midface: 84.0 }, topZone: 'Corrugator',
        interest: ['Corrugator', 'Frontalis', 'Orbicularis'], poseCount: 6,
      },
    },
    {
      consultationId: 'cons-mock-2', analysisId: 'an-mock-2', agentKey: 'serval',
      serviceName: { fa: 'تحلیل فیلر', en: 'Filler analysis' },
      state: 'preliminary', physicianName: null,
      at: new Date(Date.now() - 2 * 86400000).toISOString(), reviewedAt: null,
      metrics: {
        measures: [], harmony: 91.2, balance: 88.4, topZone: 'Lips',
        priorities: ['Lips', 'Cheek'], lipRatio: 1.62,
        needsVolumeSide: 'left', poseCount: 4,
      },
    },
    {
      consultationId: 'cons-mock-3', analysisId: 'an-mock-3', agentKey: 'lynx',
      serviceName: { fa: 'تحلیل لیفت صورت', en: 'Face lift analysis' },
      state: 'reviewed', physicianName: 'دکتر نیلوفر کریمی',
      at: new Date(Date.now() - 40 * 86400000).toISOString(),
      reviewedAt: new Date(Date.now() - 39 * 86400000).toISOString(),
      metrics: {
        measures: [], youthfulness: 72.4, overallLaxity: 31.8, topZone: 'Jawline',
        priorities: ['Jawline', 'Nasolabial'], triangleIndex: 64.1,
        balance: 93.0, descendedSide: 'right', poseCount: 5,
      },
    },
  ],
};

export async function getCandleCard() {
  await new Promise((r) => { setTimeout(r, 180); });
  return JSON.parse(JSON.stringify(MOCK));
}

export const candleCardApi = { getCandleCard };
export default candleCardApi;
